export const getFileExtension = (fileName: string): string => {
  if (!fileName) {
    return '';
  }

  const dotIndex = fileName.lastIndexOf('.');
  return fileName.slice(dotIndex);
};
